import React from 'react';
import { CheckCircle2, AlertCircle, Loader2 } from 'lucide-react';

interface SaveStatusProps {
  saving: boolean;
  saved: boolean;
  saveError: string | null;
  loadingText: string;
}

export function SaveStatus({ saving, saved, saveError, loadingText }: SaveStatusProps) {
  if (saved) {
    return (
      <span className="ml-4 inline-flex items-center text-sm text-green-600">
        <CheckCircle2 className="w-4 h-4 mr-1" />
        Dataset saved successfully
      </span>
    );
  }

  if (saveError) {
    return (
      <span className="ml-4 inline-flex items-center text-sm text-red-600">
        <AlertCircle className="w-4 h-4 mr-1" />
        {saveError}
      </span>
    );
  }

  if (saving) {
    return (
      <>
        <Loader2 className="w-4 h-4 mr-2 animate-spin" />
        {loadingText}
      </>
    );
  }

  return <>Save Dataset</>;
}